<!-- 销售预付款数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" class="baseForm" id="mainInfo" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey.isIndex, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isChange == 0"></df-date>
                                                <!-- 业务部门 -->
                                                <el-input v-else-if="formOneValue.entityField == 'depId'" :disabled="true" v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength" :readonly="formOneValue.isChange == 0"></el-input>
                                                <el-input class="form_codition" clearable @input="setMoney(scope.row.jurconfigform)" v-else-if="formOneValue.entityField == 'payMoney'" @keyup.enter.native="nextFocus(formOneKey)" :disabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                                            </el-form-item>
                                            <!-- <el-form-item>
                        <el-button type="primary" @click="openSearch('150920080887808', 0, 'wb', '')">提取外部订单
                        </el-button>
                      </el-form-item> -->
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'cmId'">{{ sendDataInfo.cmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'depId'">{{ sendDataInfo.depName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'cbiId'">{{ sendDataInfo.cmName }}</span>
                                                <span v-else-if="formOneValue.entityField == 'salesId'">{{ sendDataInfo.salesName }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{$common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{$common.getLocalTime(sendDataInfo[formOneValue.entityField],true) }}
                                                    </span>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="formDataList[3]">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in formDataList[3].jurconfigform" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "salesRefundApplyInitListAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detaislDataInfo: {},
            sendDataInfo: {
                pscamId: "",
                pscamName: "",
                payMoney: 0,
                psomBusdept: 0,
                opmName: "",
                psomReserves1: "",
                psomReserves2: "",
                psomReserves3: "",
                psomReserves4: "",
                psomReserves5: "",
                psomReserves6: "",
                salesName: "",
                depName: "",
                cmName: "",
                cbiNumber: "",
                abookCode: "", //账簿编号
                abookId: "", //	账簿id
                abookName: "", //	账簿名称
                applyTime: "", //	预收款时间
                cbiId: "", //	客户银行信息id
                checkNo: "", //	支票号
                cmId: "", //	客户id
                depId: "", //	业务部门id
                opmId: "", //	业务员id
                payMoney: "", //	预收金额
                registerTime: "", //	登记时间
                remark: "", //	备注
                salesId: "", //对方业务员id
                sprmRemark: "", //	备注
                coId: '',
                coName: '',
                spamRemark: '',
                orderId: '',
                spamId: ''
            },
            showTabs: "",
            tabForm:[],
            formDataList: [],
            salesmanList: [],
            detailsBox: {
                status: false,
                type: 0,
                title: "新增" || "修改",
            },
            seId: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            cmId: "",
            parentSearchData: {
                smId: "",
            },
            mxHeight: 0,
            isBuyer: 0,
            sField: '',
            showDialog: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.cmName": {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.sendDataInfo.cmId = ''
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.cbiId = "";
                    this.sendDataInfo.cbiNumber = "";
                    this.sendDataInfo.cbiName = "";
                    this.sendDataInfo.cbiCode = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        setMoney(jurconfigform) {
            const index = jurconfigform.findIndex(item => item.entityField == 'sxf')
            if (jurconfigform[index].isShow) {
                this.$http.feeDeduction({
                    payMoney: this.sendDataInfo.payMoney
                }).then(res => {
                    if (res.status == 200) {
                        this.sendDataInfo.sxf = res.result
                    }
                })
            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        // 赋值字段
        paramValue(val) {
            console.log(11);
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        changeInputModel(val) {
            console.log('返回', val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.cmId) {
                    this.parentSearchData.smId = val.cmId;
                }
                if (this.seType == 'wb') {
                    for (let key in this.sendDataInfo) {
                        console.log(this.sendDataInfo);
                        if (key != 'spamId' && key != "applyTime" && key != "registerTime") this.sendDataInfo[key] = val[key]
                    }
                    return
                }
                if (this.seType == "cmName") {
                    this.paramValue(val)
                    return
                }
                if (this.seType == "salesName") {
                    console.log("/////////")
                    //对方业务员
                    this.$http
                        .checkSalesSale({
                            //校验对方业务员
                            formId: this.formDataList[0].jciId, //表单ID
                            salesId: val.salesId, //业务员ID
                        })
                        .then((res) => {
                            if (res && res.status == 200) {
                                let flag = -1
                                if (res.result != null && res.result.length > 0) {
                                    this.dialogList = res.result
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.paramValue(val)
                                } else {
                                    this.showDialog = true
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.clearValue()
                                return false;
                            }

                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue()
                        });
                    return
                }

                this.paramValue(val)
            }
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == "salesName" || type == "cbiName") {
                if (this.parentSearchData.cmId == "") {
                    return this.$message({
                        message: "请先选择客户",
                        type: "warning",
                    });
                }
            }
            if (type == 'opmName') {
                this.parentSearchData['opmBuyer'] = ''
                this.parentSearchData['opmSalesperson'] = 1
            } else {
                this.parentSearchData['opmBuyer'] = ''
                this.parentSearchData['opmSalesperson'] = ''
            }
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type];
            this.DialogVisible = true;
        },

        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                    this.$emit("drawerCancel");
                })
                .catch(() => { });
        },

        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = []
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField()
            // this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.applyTime = this.$moment().valueOf();
                this.sendDataInfo.registerTime = this.$moment().valueOf();
                this.parentSearchData.smId = "";
                this.$nextTick(() => {
                    this.checkIsBuyer();
                })
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.getMainInput()
                    this.initFocus()
                }, 16.7)
            });
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        //确认新增
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.suRefundAdd(this.sendDataInfo);
            } else if (this.dataActionBox.actionType == 1) {
                var responseData = await this.$http.suRefundModifyRefund(this.sendDataInfo);
            }
            if (responseData.status == 200) {
                this.$emit("drawerCancel");
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },


        // 判断是不是采购员
        checkIsBuyer() {
            console.log(121212)
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmSalesperson == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBox();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>